<template>
  <main>
    <h1 class="text-green">{{this.dat.Title}}</h1>
    <h3>Por favor valide la información a continuación e indique si autoriza o declina la asociación del registro aportante.</h3>
    <form>
        <div class="form-footer">
            <div class="center">
                <div style="
              position: static;
              width: 100% !important;
              height: 6em !important;
              margin: auto;
              background-color: #ffffffa3;
          ">
                    <div class="center" style="
                      width: 70% !important;
                      height: 8em !important;
                      margin: auto;
                      background-color: #ffffffa3;
                      border:solid;
                      border-style:ridge;
                      border-color:lightgray;
                      text-align:left !important;
                      padding: 10px;
                      word-wrap: break-word;
                      ">
                        <h4>Información del usuario solicitante </h4>
                        <br />
                        <p>Usuario Solicitante:{{NombreUsuarioSolicitante}}</p>
                        <p>Correo Electrónico: {{CorreoElectronicoSolicitante}}</p>
                    </div>
                    <div class="center" style="
                      width: 70% !important;
                      height: 10em !important;
                      margin: auto;
                      background-color: #ffffffa3;
                      border:solid;
                      border-style:ridge;
                      border-color:lightgray;
                      text-align:left !important;
                      padding: 10px;
                      word-wrap: break-word;
                      ">
                        <h4>Información del registro del aportante</h4>
                        <br />
                        <p>Tipo de identificación: {{TipoDocumentoAportante}}</p>
                        <p>Número de Identificación: {{NumeroDocumentoAportante}}</p>
                        <p>Fecha de registro: {{FechaRegistro}}</p>
                    </div>
                    <Btn action="submit(true)"
                         type="green"
                         style="display:inline-block"
                         @click.prevent="submit(true)">{{Submit}}</Btn>
                    <Btn action="submit(false)"
                         type="orange"
                         @click.prevent="submit(false)">{{SubmitDenegade}}</Btn>

                </div>
            </div>           
        </div>
    </form>
    <Spinner v-if="loading" type="modern"></Spinner>
  </main>
</template>

<script>
import api from "../api/Autorizar";
import Btn from "../components/UIElements/Btn";
import Spinner from "../components/UIElements/Spinner";
export default {
  name: "FormReport",
  components: { Btn, Spinner },
  data() {
    return {
      emptyData: true,
        loading: true,
        NombreUsuarioSolicitante: "",
        CorreoElectronicoSolicitante: "",
        TipoDocumentoAportante: "",
        NumeroDocumentoAportante: "",
        FechaRegistro: "",
      dat: {
        Title: "Autorizar Asociación del Aportante",
        Inputs: [],
        FileName: "",
        Data: {}
      },
        Submit: "Autorizar",
        SubmitDenegade: "Declinar",
      token: {},
      id: ""
      };
  },
        async created() {
            this.loading = true;
            await this.getData(this.$route.params.id);
  },
  methods: {
      async getData(id) {
      this.id = id;

      try {
          var resp = await api.get(this, id);
          if (!resp.error) {
              this.dat = resp;
          }
          this.NombreUsuarioSolicitante = this.dat.Data.Data.NombreUsuarioSolicitante;
          this.CorreoElectronicoSolicitante = this.dat.Data.Data.CorreoElectronicoSolicitante;
          this.TipoDocumentoAportante = this.dat.Data.Data.TipoDocumentoAportante;
          this.NumeroDocumentoAportante = this.dat.Data.Data.NumeroDocumentoAportante;
          this.FechaRegistro = this.dat.Data.Data.FechaRegistro;
      } catch (e) {
          this.$alert("Ocurrió un error al intentar consultar tu link");
      } finally {
        this.loading = false;
      }
      return true;
      }, 
      async submit(Estado) {
            this.loading = true;

            var dat = {
                id: this.id,
                estado: Estado,
                Data: this.dat.Data.Data
            };
            try {
                let respuesta = await api.post(this, dat);
                this.$confirm(respuesta.data).then(() => {
                    this.loading = true;
                    document.location = this.dat.FileName;
                });
            } catch (e) {
                this.$alert(
                    "Ocurrió un error al intentar asociar el usuario "
                ).then(() => {
                    document.location = window.location.protocol + "//" + window.location.host + "/index.html#/";
                });
            } finally {
                this.loading = false;
            }
      }
  }
};
</script>

<style>

form {
  margin: 1em auto;
}

    form .form-footer {
        width: 100%;
        height: 20em !important;
        box-sizing: border-box;
        float: left;
        margin-bottom: 10px;
    }

form .form-item {
  width: 100%;
  box-sizing: border-box;
  float: left;
  margin: 1em auto;
}

form label {
  display: block;
  padding: 0.5em 0;
  color: #777;
}

form input[type=text], form input[type=number], form input[type=email], form textarea {
  outline: none;
  text-align: center;
  border-width: 0px 0px 1px;
  border-top-style: initial;
  border-right-style: initial;
  border-bottom-style: solid;
  border-left-style: initial;
  border-top-color: initial;
  border-right-color: initial;
  border-bottom-color: rgb(204, 204, 204);
  border-left-color: initial;
  border-image: initial;
  background-color: white;
  font: inherit;
  display: block;
  width: 20em;
  box-sizing: border-box;
  color: #777;
  font-weight: 600;
  margin: auto;
}

.form-footer {
  margin-top: 1.5em;
}

@media screen and (max-width: 320px) {
  form input[type=text], form input[type=number], form input[type=email] {
    width: 18em;
  }
}
</style>
